import React, { useState, useEffect } from 'react';
import Navigation from '../Navbar/Navbar';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import './AddSignout.css';


const apiUrl = "/api";

const delay = ms => new Promise(
  resolve => setTimeout(resolve, ms)
);
function AddSignout() {
  const [agentList, setAgentList] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState('');
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      // Redirect to login page if not logged in 
      window.location.href = '#/login';
      return null;
    }
    // Fetch the list of agents when the component mounts
    const tenantId = parseInt(localStorage.getItem('selectedTenant')) || 1;
    const token = localStorage.getItem('token');
    axios.get(apiUrl + `/getallagents?tenant_id=${tenantId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        setAgentList(res.data);
        //console.log(res.data);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  const handleAddSignout = () => {
    // Ensure that a valid agent is selected before making the API call
    if (!selectedAgent) {
      console.error('Please select an agent before adding a signout.');
      return;
    }
  
    // Make an API call to add the signout to the database
    const tenantId = parseInt(localStorage.getItem('selectedTenant')) || 1;
    const token = localStorage.getItem('token');
    axios.post(apiUrl +'/createsignout', { agentid: selectedAgent, tenant_id: tenantId }, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((response) => {
        console.log(response.data);
        setShowAlert(true);
        setSelectedAgent('');
        delay(2000);

        window.location.href = '#/inv/signout/?id='+ response.data.id;


      })
      .catch((error) => {
        console.error('Error adding signout:', error);
      });


  };

  return (
    <div>
        <Navigation />
        <Container className="mt-4">
            <Row className="mb-4">
                <Col>
                    <h1 className="text-center mb-4 add-signout-heading">
                        Create New Signout
                    </h1>
                </Col>
            </Row>
            <div className="add-signout-container">
                <div className="add-signout-box">
                    <Alert variant="success" show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                        Signout added successfully! Redirecting
                    </Alert>
                    <Form>
                        <Form.Group controlId="agentSelect" className="mb-3">
                            <Form.Label>Select Agent</Form.Label>
                            <Form.Control
                                as="select"
                                value={selectedAgent}
                                onChange={(e) => setSelectedAgent(e.target.value)}
                                className="agent-select"
                            >
                                <option value="" disabled>Select an agent</option>
                                {agentList.map(agent => (
                                    <option key={agent.id} value={agent.id}>{agent.name} ({agent.tenant_name})</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Button variant="primary" className="custom-button" onClick={handleAddSignout}>
                            Add Signout
                        </Button>
                    </Form>
                </div>
            </div>
        </Container>
    </div>
  );
}

export default AddSignout;
